import React, {useEffect, useState} from 'react'
import {Link, useHistory, useParams} from 'react-router-dom'
import {
    Flex,
    Text,
    Box,
    Heading,
    Divider,
    Input,
    HStack,
    Select,
    Grid,
    Button,
    GridItem, useDisclosure, useToast, Menu, MenuButton, MenuList, MenuItem,
} from '@chakra-ui/react'
import Navbar from '../../components/Navbar'
import {SPECIALITIES} from '../../constants'
import styles from './styles'
import ChartCompany from '../../components/Theme/ChartCompany'
import {Checkbox, Incrementer, InputLabel, TextareaLabel} from "../../components/Theme";
import HeaderCompanyAdmin from "../CompanyEditAdmin/Header";
import {useForm} from "react-hook-form";
import {STATES} from "../../constants/serviceableAreas"
import ServiceableAreas from "../EditCompany/Modals/ServiceableAreas";
import {ReactComponent as Edit_Modal} from "../../assets/edit_modal.svg";
import {ReactComponent as DownIcon} from "../../assets/downArrow.svg";
import {useCreateCompany, useUser} from "../../core/hooks";
import {COMPANY_OBJECT, EU_COMPANY_TYPE, REU_COMPANY_TYPE, SU_COMPANY_TYPE} from "../../constants/company/companyEnum";
import {EU, REU, SU} from "../../constants/user/userEnum";
import stylesCheckbox from "../CompanyEditAdmin/styles";
import {ReactComponent as DoneIcon} from "../../assets/Icons/DoneIcon.svg";
import {createMuiTheme} from "@material-ui/core/styles";
import httpRequest from "../../core/services/http-request";
import {capitalize} from "@material-ui/core";

const initialScore = {
    office: 0,
    industrial: 0,
    retail: 0,
    multi: 0,
    hospitality: 0,
    parking: 0,
    horticulture: 0,
    healthcare: 0,
    data: 0,
    other: 0,
}

const CompanyDetail = () => {
    const params = useParams()
    const {user} = useUser()
    const history = useHistory()
    const toast = useToast()
    const [score, setScore] = useState(initialScore)
    const [serviceArea, setServiceArea] = useState([])
    const [companyType, setCompanyType] = useState('')
    const [country, setCountry] = useState('USA')
    const {isOpen, onOpen, onClose} = useDisclosure()
    const [error, setError] = useState('')
    const {createCompany, isLoading} = useCreateCompany()
    const {formState: {errors}, register, handleSubmit, setValue, watch}
        = useForm(
            {
                defaultValues: {
                    ...COMPANY_OBJECT,
                    ownerId: ''
                }
            })
    const image = watch('image', '')
    const [users, setUsers] = useState([])
    const {post} = httpRequest()

    const getUsers = () => {
        post('all-users-select',{
            type: capitalize(params.type === 'reu' ? 'reu' : params.type === 'su' ? SU : 'eu'),
        }).then((e) => {
            setUsers(e.data.data)
        }).catch(() => {
        })
    }

    const submit = (data) => {
        if (serviceArea.length < 1 && params.type === 'eu') {
            return setError('Chose area')
        }
        setError('')
        const input = {
            ...data,
            // ownerId: user?.id,
            ownerId: Number(data?.ownerId),
            status: 'review',
            type: companyType,
            country: country,
            serviceArea: [JSON.stringify(serviceArea)],
            propertyPriorities: [JSON.stringify(score)],
            seen: false,
        }
        createCompany(
            input,
            {
                onSuccess: ({data}) => {
                    setError('')
                    toast({
                        render: () => (
                            <Flex
                                overflow='hidden'
                                position='relative'
                                justifyContent='center'
                                flexDirection='column'
                                borderRadius='4px 0px 0px 4px'
                                marginTop='80px'
                                color='black'
                                bg='#8FCF74'
                                pl={3}
                                width='530px'
                                fontWeight='600'
                                fontSize='14px'
                                height='40px'>
                                <Flex
                                    alignItems='center'>
                                    <Text
                                        ml={2}>
                                        Your Company information was submitted!
                                    </Text>
                                </Flex>
                                <Box
                                    css={styles.toast}
                                    position='absolute'
                                    left='5px'
                                    bottom='0'
                                    mt={1}
                                    borderRadius='6px'
                                    backgroundColor='#D5D5D5'
                                    height='3px'
                                    width='40px'>
                                </Box>
                            </Flex>
                        ),
                        duration: 4000,
                        isClosable: true,
                        position: "top-right"
                    })
                    history.goBack()
                },
                onError: (e) => setError(e.response.data.errorMessage),
            },
        )
    }

    useEffect(() => {
        if (Object.keys(errors).length > 0) {
            return setError(`Please fill in the required fields to submit Company Details...`)
        }
    }, [errors])

    useEffect(() => {
        getUsers()
    }, [])

    return (
        <>
            <form
                noValidate
                onSubmit={handleSubmit(submit)}>
                <Navbar
                    minW="1240px"
                    title={(
                        <Flex>
                            <Link
                                to="/companies">
                                Companies
                            </Link>
                                &nbsp;/&nbsp;
                                {
                                    params.type === 'reu' ? 'Real Estate' :
                                        params.type === 'su' ? 'Luminaire Types' :
                                            params.type === 'eu' ? 'Electrical Contractor' : ''
                                }
                        </Flex>
                    )}>
                    <Button
                        bg="#C2EF62"
                        color="black"
                        mr={8}
                        ml={12}
                        px={8}
                        isLoading={isLoading}
                        w="135px"
                        type="submit"
                        h="40px">
                        <DoneIcon/>
                        <Text
                            fontWeight="700"
                            ml={1}
                            mt="2px">
                            Done
                        </Text>
                    </Button>
                </Navbar>
                <Box
                    minW="1240px"
                    margin="auto"
                    maxW="1240px"
                    css={styles.container}
                    px={14}
                    pt={8}
                    pb={16}
                    borderRight="1px solid"
                    borderLeft="1px solid"
                    borderColor="#DBDADA"
                    bg="#f5f5f5">
                    <Flex
                        w="full"
                        direction="row"
                        flexWrap="wrap"
                        position='relative'
                        alignItems="center"
                        justifyContent="space-between"
                        mt={4}>
                        <Box>
                            <HeaderCompanyAdmin
                                setValue={setValue}
                                image={image}/>
                        </Box>
                        <Box
                            width="510px"
                            mb={12}>
                            <Input
                                isInvalid={!!errors.name}
                                {...register('name',{required: true})}
                                fontWeight="700"
                                bg="white"
                                height='50px'
                                fontSize="24px"
                                color="black !important"
                                border="1px solid #C4C4C4 !important"
                                mr={7}/>
                        </Box>
                        <Flex width='45%' alignItems='center' mb={12}>
                            <Text
                                pl={5}
                                mr={5}
                                whiteSpace='nowrap'
                                fontSize='xl'>
                                Company Type:
                            </Text>
                            <Menu closeOnSelect={false} width='100%'>
                                <MenuButton
                                    width='100%'
                                    as={Flex}
                                    px={4}
                                    alignItems="center"
                                    border="1px solid"
                                    overflow="scroll"
                                    borderColor="rgba(169, 169, 169, 0.87)"
                                    borderRadius="5px"
                                    bg="white.100"
                                    justifyContent='space-between'
                                    height="50px">
                                    <Flex justifyContent='space-between' alignItems='center'>
                                        <Text
                                            whiteSpace="nowrap"
                                            fontSize="xl">
                                            {companyType}
                                        </Text>
                                        <DownIcon />
                                    </Flex>
                                </MenuButton>
                                <MenuList
                                    inset='-10px auto auto 0'
                                    p={0}
                                    width='350px'>
                                    {
                                        params?.type === 'reu' ? (
                                            Object.entries(REU_COMPANY_TYPE).map(([key, value]) => (
                                                <MenuItem
                                                    width='100%'
                                                    onClick={(e) => e.stopPropagation()}
                                                    justifyContent="space-between"
                                                    key={key}
                                                    colSpan={1}>
                                                    <Flex
                                                        justifyContent='space-between'>
                                                        <Checkbox
                                                            mr={6}
                                                            css={stylesCheckbox.checkboxComp}
                                                            isChecked={companyType === value}
                                                            onChange={() => setCompanyType(value)}
                                                            name={value}
                                                            iconColor="black"
                                                            colorScheme="whiteAlpha">
                                                        </Checkbox>
                                                        <Text
                                                            fontSize='18px'>
                                                            {value}
                                                        </Text>
                                                    </Flex>
                                                </MenuItem>
                                            ))
                                        ) : params?.type === 'su' ? (
                                            Object.entries(SU_COMPANY_TYPE).map(([key, value]) => (
                                                <MenuItem
                                                    justifyContent="space-between"
                                                    key={key}
                                                    onClick={(e) => e.stopPropagation()}
                                                    colSpan={1}>
                                                    <Flex
                                                        justifyContent='space-between'>
                                                        <Checkbox
                                                            mr={6}
                                                            css={stylesCheckbox.checkboxComp}
                                                            isChecked={companyType === value}
                                                            onChange={() => setCompanyType(value)}
                                                            name={value}
                                                            iconColor="black"
                                                            colorScheme="whiteAlpha">
                                                        </Checkbox>
                                                        <Text
                                                            fontSize='18px'>
                                                            {value}
                                                        </Text>
                                                    </Flex>
                                                </MenuItem>
                                            ))
                                        ) : params?.type === 'eu' ? (
                                                Object.entries(EU_COMPANY_TYPE).map(([key, value]) => (
                                                    <MenuItem
                                                        onClick={(e) => e.stopPropagation()}
                                                        justifyContent="space-between"
                                                        key={key}
                                                        colSpan={1}>
                                                        <Flex
                                                            justifyContent='space-between'>
                                                            <Checkbox
                                                                mr={6}
                                                                css={stylesCheckbox.checkboxComp}
                                                                isChecked={companyType === value}
                                                                onChange={() => setCompanyType(value)}
                                                                name={value}
                                                                iconColor="black"
                                                                colorScheme="whiteAlpha">
                                                            </Checkbox>
                                                            <Text
                                                                fontSize='18px'>
                                                                {value}
                                                            </Text>
                                                        </Flex>
                                                    </MenuItem>
                                                ))
                                            ) :
                                            <MenuItem
                                                onClick={(e) => e.stopPropagation()}
                                                justifyContent="space-between"
                                                colSpan={1}>
                                                <Flex
                                                    justifyContent='space-between'>
                                                    <Checkbox
                                                        mr={6}
                                                        css={stylesCheckbox.checkboxComp}
                                                        isChecked={companyType === 'Admin'}
                                                        onChange={() => setCompanyType('Admin')}
                                                        name='Admin'
                                                        iconColor="black"
                                                        colorScheme="whiteAlpha">
                                                    </Checkbox>
                                                    <Text
                                                        fontSize='18px'>
                                                        Admin
                                                    </Text>
                                                </Flex>
                                            </MenuItem>
                                    }
                                </MenuList>
                            </Menu>
                        </Flex>
                    </Flex>
                    <Divider
                        my={10}
                        borderColor="#DADADA"
                        border="3px solid"
                        orientation="horizontal"/>
                    {
                        error && (
                            <Text
                                color="red.100"
                                fontSize="m">
                                {error}
                            </Text>
                        )
                    }
                    <Flex
                        w="100%">
                        <InputLabel
                            isInvalid={!!errors.address}
                            {...register('address',{required: true})}
                            mr={7}
                            label="Address:"/>
                        <InputLabel
                            {...register('address2')}
                            ml={5}
                            label="Address Line 2:"/>
                    </Flex>
                    <HStack
                        pt="60px"
                        spacing="16"
                        alignItems="center"
                        justifyContent="space-between">
                        <InputLabel
                            isInvalid={!!errors.city}
                            {...register('city',{required: true})}
                            maxW="170px"
                            label="City:"/>
                        <label>
                            <Text
                                as="span"
                                width="105px"
                                color="#2C628D"
                                fontWeight="600"
                                fontFamily='Titillium Web'
                                fontSize='md'
                                display="inline-block"
                                pb="4px">
                                State:
                            </Text>
                            <Select
                                label="State:"
                                mt="2px"
                                isInvalid={!!errors.state}
                                {...register('state',{required: true})}
                                border="1px solid #C4C4C4 !important"
                                name="state"
                                fontSize='md'
                                height='50px'
                                bg="white" maxW="105px">
                                {
                                    STATES.map((item, idx) => (
                                        <option
                                            key={idx}>
                                            {item}
                                        </option>
                                    ))
                                }
                            </Select>
                        </label>
                        <InputLabel
                            isInvalid={!!errors.zipCode}
                            {...register('zipCode',{required: true})}
                            maxW="105px"
                            label="Zip Code:"/>
                        <InputLabel
                            value={country}
                            onChange={(e) => setCountry(e.target.value)}
                            maxW="540px"
                            label="Country:"/>
                    </HStack>
                    <Flex
                        w="100%"
                        pt="60px">
                        {/*<InputLabel*/}
                        {/*    readOnly*/}
                        {/*    mr={7}*/}
                        {/*    label="Associated Users:"/>*/}
                        <Box w="50%">
                            <label>
                                <Text
                                    as="span"
                                    color="#2C628D"
                                    fontWeight="600"
                                    fontFamily='Titillium Web'
                                    fontSize='md'
                                    display="inline-block"
                                    pb="4px">
                                    Users:
                                </Text>
                                <Select
                                    mt="2px"
                                    isInvalid={!!errors.ownerId}
                                    {...register('ownerId',{required: true})}
                                    border="1px solid #C4C4C4 !important"
                                    name="ownerId"
                                    fontSize='md'
                                    height='50px'
                                    bg="white"
                                >
                                    <option value="" disabled hidden></option>
                                    {
                                        users.map((item, idx) => (
                                            <option
                                                key={idx}
                                                value={item.id}
                                            >
                                                {item.firstName} {item.lastName}
                                            </option>
                                        ))
                                    }
                                </Select>
                            </label>
                        </Box>
                        <Box w="50%">
                            <InputLabel
                                ml={7}
                                isInvalid={!!errors.website}
                                {...register('website',{required: true})}
                                label="Website:"/>
                        </Box>
                    </Flex>
                    <Flex
                        w="100%"
                        pt="20px">
                        <TextareaLabel
                            isInvalid={!!errors.notes}
                            {...register('notes',{required: true})}
                            label="Notes:"/>
                    </Flex>
                    <Divider
                        my={10}
                        borderColor="#DADADA"
                        border="3px solid"
                        orientation="horizontal"/>
                    <Heading
                        mb={10}
                        fontSize="xl"
                        as="h2">
                        {
                            user?.type === 'Reu' ? (
                                'Property Types:'
                            ) : ('Serviceable Property Types:')
                        }
                    </Heading>
                    <Flex
                        alignItems="center"
                        justifyContent="space-between">
                        <Grid
                            templateColumns="repeat(2, 1fr)"
                            gap={5}>
                            {
                                SPECIALITIES.map((interest) => (
                                    <GridItem
                                        key={interest.title}
                                        colSpan={1}>
                                        <Incrementer
                                            plus
                                            score={score}
                                            setScore={setScore}
                                            title={interest.title}
                                            color={interest.active}/>
                                    </GridItem>
                                ))
                            }
                        </Grid>
                        <ChartCompany
                            score={score}/>
                    </Flex>
                    <Divider
                        mb="4.25rem"
                        borderColor="#DADADA"
                        border="3px solid"
                        display={params.type === 'eu' ? 'block' : 'none'}
                        orientation="horizontal"/>
                    <Box
                        w='full'
                        display={params.type === 'eu' ? 'block' : 'none'}>
                        <Flex
                            w="100%">
                            <Text
                                fontWeight='600'
                                mb={5}
                                fontSize='18px'>
                                Serviceable Areas:
                            </Text>
                        </Flex>
                        <Flex
                            w="100%">
                            <Text
                                fontWeight='600'
                                fontSize='14px'
                                color="#2C628D">
                                Serviceable Areas - States & Counties
                            </Text>
                        </Flex>
                        <Flex
                            w="100%"
                            border="1px solid #C4C4C4"
                            borderRadius="5px"
                            justifyContent="space-between"
                            p="10px"
                            mb={20}>
                            <Text
                                fontWeight='400'
                                fontSize='18px'>
                                {(() => {
                                    if (serviceArea.length > 0) {
                                        let a = serviceArea?.map((item) => item.name + '(' + item.child.map((e) => e.name) + ')-')
                                        let res = a[a.length - 1].slice(0, -1)
                                        a.pop()
                                        a.push(res)
                                        return a?.toString()?.replace(/(.{100})..+/, "$1…")
                                    }
                                })()}
                            </Text>
                            {
                                user &&  <ServiceableAreas
                                    userType={user.type}
                                    serviceArea={serviceArea}
                                    setServiceArea={setServiceArea}
                                    isOpen={isOpen}
                                    onClose={onClose}/>
                            }

                            <Button
                                onClick={onOpen}
                                leftIcon={<Edit_Modal/>}
                                w="60px"
                                height="22px"
                                variant="primary"
                                backgroundColor="#FFE68D">
                                <Text
                                    mt={1}
                                    color="black">
                                    Edit
                                </Text>
                            </Button>
                        </Flex>
                    </Box>
                </Box>
            </form>
        </>
    )
}

export default CompanyDetail
